module.exports = __webpack_public_path__ + "media/images/sites/health/bg-header-ab4714038c09cac0ae0ea8a4db8df7c4.png";